import {cva} from 'class-variance-authority'

/**
 * v3 Dialog surface (MUI `Dialog` paper): white `background` surface, 8px radius,
 * `elevation-2` shadow. Sizes are the Figma widths (Small 250 / Medium 620 /
 * Large 800), capped responsively with `max-w` so they never overflow the viewport.
 */
export const DialogPanelVariants = cva(
  'relative flex w-full flex-col rounded-lg bg-background shadow-elevation-2 focus:outline-none',
  {
    variants: {
      size: {
        small: 'max-w-[250px]',
        medium: 'max-w-[620px]',
        large: 'max-w-[800px]',
      },
    },
    defaultVariants: {size: 'medium'},
  },
)
